import { useEffect, useState } from "react";
import config from "../config";

export function useProductos() {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProductos = async () => {
      try {
        console.log('🔍 Intentando cargar productos desde:', config.api.baseUrl);
        
        const response = await fetch(`${config.api.baseUrl}/products`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });

        console.log('📡 Response status:', response.status);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('✅ Productos cargados:', data.length);
        
        setProductos(data);
        setLoading(false);
      } catch (err) {
        console.error('❌ Error al cargar productos:', err);
        setError(err.message || 'Error desconocido');
        setLoading(false);
      }
    };

    fetchProductos();
  }, []);

  // Solo retorna datos, nunca JSX
  return { productos, loading, error };
}

